import { createSelector } from 'reselect';
import { getUserItemsById } from 'state/items/selectors';
import { PromoAfterItemUpload } from './constants';

const select = state => state.profile;

const selectUi = state => select(state).ui;

const selectUploadedItem = state => select(state).uploadedItem;

export const getCurrentPromotion = createSelector(selectUi, _ref => {
  let {
    currentPromotion
  } = _ref;
  return currentPromotion;
});
export const getUploadedItemId = createSelector(selectUploadedItem, _ref2 => {
  let {
    id
  } = _ref2;
  return id;
});
export const getFeedbackItemId = createSelector(selectUploadedItem, _ref3 => {
  let {
    feedbackItemId
  } = _ref3;
  return feedbackItemId;
});
export const getUploadedItemPushedUpId = createSelector(selectUploadedItem, _ref4 => {
  let {
    pushedUpId
  } = _ref4;
  return pushedUpId;
});
export const getPromotedItemId = createSelector(select, _ref5 => {
  let {
    promotedItemId
  } = _ref5;
  return promotedItemId;
});
export const getPromotedItem = createSelector(getPromotedItemId, getUserItemsById, (itemId, items) => itemId && items[itemId] || null);
export const getIsPromoShown = createSelector(select, // TODO: `state` can be `undefined` in `/pro` page, causing the page to crash if `select` is used and destructured.
// E. g. https://github.com/vinted/core/pull/77652. Investigate this.
state => {
  var _state$ui, _state$ui2;

  return Boolean(state === null || state === void 0 ? void 0 : (_state$ui = state.ui) === null || _state$ui === void 0 ? void 0 : _state$ui.currentPromotion) && (state === null || state === void 0 ? void 0 : (_state$ui2 = state.ui) === null || _state$ui2 === void 0 ? void 0 : _state$ui2.currentPromotion) !== PromoAfterItemUpload.Empty;
});